var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCastAwards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Smooth",
    enableBackground: "new 0 0 128 128",
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 17,
    x2: 126,
    y1: 45.5,
    y2: 45.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#93634d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93634d"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#abafb2"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 31,
    x2: 121,
    xlinkHref: "#lg1",
    y1: 61.5,
    y2: 61.5
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.003,
    x2: 29.007,
    xlinkHref: "#lg2",
    y1: 103.502,
    y2: 103.502
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e5e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#a9aea7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c8378"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.493,
    x2: 23.811,
    xlinkHref: "#lg3",
    y1: 67.795,
    y2: 77.613
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 30,
    x2: 42,
    xlinkHref: "#lg2",
    y1: 92,
    y2: 92
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 34,
    x2: 54,
    xlinkHref: "#lg1",
    y1: 96.5,
    y2: 96.5
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 48,
    x2: 61,
    xlinkHref: "#lg2",
    y1: 105,
    y2: 105
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.594,
    x2: 106.761,
    xlinkHref: "#lg3",
    y1: 119.511,
    y2: 121.302
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.181,
    x2: 107.348,
    xlinkHref: "#lg3",
    y1: 116.835,
    y2: 118.627
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.83,
    x2: 101.663,
    y1: 100.321,
    y2: 103.071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0399,
    stopColor: "#fc9f4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f68741"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.472,
    x2: 114.639,
    y1: 64.789,
    y2: 87.622
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0487,
    stopColor: "#f47e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb5c43"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m123 2c-51.719 0-87.276 46.862-106 81l11 6c17.316-34.03 49.716-79.139 95-81 1.657 0 3-1.343 3-3s-1.343-3-3-3z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m120 116c-.552 0-1-.448-1-1v-103.724c-6.025 7.959-14.23 9.902-23.044 5.39-.44 5.223-3.65 10.527-8.674 14.173-5.318 3.859-11.513 5.118-17.214 3.549.07 5.346-1.895 10.626-5.617 15.01-3.952 4.655-9.438 7.699-15.2 8.473 1.392 6.031.632 11.645-2.218 16.297-3.048 4.974-8.314 8.458-14.829 9.811-.542.109-1.07-.235-1.182-.776s.235-1.07.776-1.182c5.969-1.239 10.773-4.399 13.53-8.897 2.733-4.461 3.324-9.945 1.708-15.86-.078-.288-.024-.595.146-.838s.442-.398.739-.422c5.659-.453 11.128-3.332 15.005-7.899 3.717-4.377 5.52-9.712 5.078-15.021-.028-.34.119-.67.389-.877.271-.207.629-.26.949-.146 5.439 1.978 11.552.944 16.765-2.839 5.04-3.658 8.064-9.094 7.894-14.188-.012-.365.175-.707.489-.894.313-.186.703-.187 1.018-.002 9.366 5.513 17.76 3.15 23.635-6.652.231-.385.69-.569 1.125-.45.432.12.732.514.732.964v107c0 .552-.448 1-1 1z",
    fill: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m27 85-6.021-2.984c-3.603-2.075-5.2-.545-5.979.984-6.359 12.475-9.702 23.838-12.001 30.078-5.249 14.672 11.813 17.578 15.001 4.922l10-27c1.352-3.242 1.634-4.29-1-6z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 92,
    fill: "url(#SVGID_4_)",
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 92,
    fill: "url(#SVGID_5_)",
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 90h-12.893c-.996 0-1.92.681-2.08 1.664-.204 1.253.758 2.336 1.973 2.336h13c.552 0 1 .448 1 1v8h4v-8c0-2.761-2.239-5-5-5z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59 108h-9c-1.1 0-2-.9-2-2v-2c0-1.1.9-2 2-2h9c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m123 127c-1.193 0-2.267-.525-3-1.357-.733.832-1.807 1.357-3 1.357-2.206 0-4-1.794-4-4 0-.553.447-1 1-1s1 .447 1 1c0 1.103.897 2 2 2s2-.897 2-2c0-.553.447-1 1-1s1 .447 1 1c0 1.103.897 2 2 2s2-.897 2-2c0-.553.447-1 1-1s1 .447 1 1c0 2.206-1.794 4-4 4z",
    fill: "url(#SVGID_8_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m119 119v4c0 .553.447 1 1 1s1-.447 1-1v-4z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m120 111c-2.2 0-4-1.8-4-4 0-2.2 1.8-4 4-4 2.2 0 4 1.8 4 4 0 2.2-1.8 4-4 4z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123 119h-6c-1.1 0-2-.9-2-2 0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2 0 1.1-.9 2-2 2z",
    fill: "url(#SVGID_11_)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastAwards);
export default __webpack_public_path__ + "static/media/castAwards.91f55329a5fa42e48bba201555838c94.svg";
export { ForwardRef as ReactComponent };